export const ClickTrackerConstants = {
    CLICK_TRACKER_STATE: 'auth.application.detail.growth.clicktracker',
    ICEBREAKER_STATE: 'auth.application.detail.growth.icebreaker',
    CONVERSATION_SETTINGS_STATE: 'auth.application.detail.growth.conversationSettings',
    CONVERSATION_SETTINGS_CONNECTIONS_STATE: 'auth.application.detail.growth.conversationSettingsConnections',
    CONVERSATION_SETTINGS_EVENTS_STATE: 'auth.application.detail.growth.conversationSettingsEvents',
};
